export default __webpack_public_path__ + "static/DSC_0078-729832adf88ae6fa501823d93ea23975.jpg";